<template lang="pug">
#detail
  .container.custom_container_lg
    .row
      breadcrumb
  section.container.i_pt_16.i_pt_sm_6
    div.multipleButtons
     div.audioGuide
      audioGuide(
       :sourcedefault="audioFiles.default"
       :sourcefast="audioFiles.fast"
       :sourceslow="audioFiles.slow"
       )
     div
      theme 
    
    .row.imageArea
      .col-md-6
        h1 {{ detail.Title }}
        p.i_body_l.i_pl_4.i_ptb_1.i_mt_3.d-none.d-md-block {{ detail.Brief }}
      .col-md-6.i_mt_sm_6
        .img(
          v-if="detail.ContentImage",
          :style="{ backgroundImage: 'url(' + detail.ContentImage + ')' }"
        )
      .col-md-6.i_mt_sm_8.d-md-none 
        p.i_body_l.i_pl_4.i_ptb_1 {{ detail.Brief }}
    .row.i_mt_8
      .col-12.date {{ detail.PostDate }}
      .col-12.content.i_body_l.i_mt_4.i_mt_md_2.detail-content(v-html="detail.Content")
      .col-12.i_mt_8.i_mb_10
        router-link.btn_square(
          v-if="false",
          tag="a",
          :to="{ name: 'CustomerServiceContactUs' }"
        ) 聯絡我們
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import {
  getNews,
  getAnnouncement,
  getPublicWelfare,
  getEmployeeCareNews,
} from "@/json/about_us";
import { getDecree } from "@/json/menu";
import Breadcrumb from "@/components/common/Breadcrumb";

import Theme from "@/components/customer_service/Theme";
import AudioGuide from "@/components/customer_service/AudioGuide";

export default {
  name: "Detail",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
    theme : Theme,
    audioGuide : AudioGuide,
  },
  data() {
    return {
      type: this.$route.query.type,
      id: this.$route.query.id,
      detail: {},

      news: {},
      announcement: {},
      publicWelfare: {},
      employeeCareNews: {},
      decree: {},

      newsBreadcrumb: [
        {
          name: "首頁",
          link: "/",
        },
        {
          name: "認識我們",
          link: "/aboutus",
        },
        {
          name: "最新消息",
          link: "/aboutus/news",
        },
        {
          name: "最新消息內容",
        },
      ],

      announcementBreadcrumb: [
        {
          name: "首頁",
          link: "/",
        },
        {
          name: "認識我們",
          link: "/aboutus",
        },
        {
          name: "公告資訊",
          link: "/aboutus/news",
        },
        {
          name: "公告資訊內容",
        },
      ],

      publicWelfareBreadcrumb: [
        {
          name: "首頁",
          link: "/",
        },
        {
          name: "認識我們",
          link: "/aboutus",
        },
        {
          name: "永續發展",
          link: "/aboutus/socialresponsibility",
        },
        {
          name: "公益足跡",
          link: "/aboutus/socialresponsibility/news",
        },
        {
          name: "公益足跡內容",
        },
      ],

      employeeCareNewsBreadcrumb: [
        {
          name: "首頁",
          link: "/",
        },
        {
          name: "認識我們",
          link: "/aboutus",
        },
        {
          name: "永續發展",
          link: "/aboutus/socialresponsibility",
        },
        {
          name: "員工照顧",
          link: "/aboutus/socialresponsibility/staffcare",
        },
        {
          name: "員工照顧內容",
        },
      ],

      decreeBreadcrumb: [
        {
          name: "首頁",
          link: "/",
        },
        {
          name: "政令宣導",
          link: "/decree",
        },
        {
          name: "政令宣導內容",
        },
      ],
      audioFiles: {
        default:"",
        fast:"",
        slow:"",
      }
    };
  },
  created() {
    this.getDetailData();
    localStorage.setItem('Mode', 'default');
    document.documentElement.setAttribute('data-theme', 'default');
    // document.documentElement.setAttribute('data-theme', 'default');
  },
   methods: {
    getDetailData() {
      if ("news" == this.type) {
        this.$route.meta.breadcrumb = this.newsBreadcrumb;
        getNews().then((response) => {
          this.news = response.data;
          for (let index in this.news.NewsList) {
            let temp = this.news.NewsList[index];
            if (this.id == temp.ID) {
              this.detail = temp;
              if (temp.AudioGuide) {
            this.audioFiles.default = temp.AudioGuide.default;
            this.audioFiles.fast = temp.AudioGuide.fast;
            this.audioFiles.slow = temp.AudioGuide.slow;
          }
              break;
            }
          }
        });
      } else if ("announcement" == this.type) {
        this.$route.meta.breadcrumb = this.announcementBreadcrumb;
        getAnnouncement().then((response) => {
          this.announcement = response.data;
          for (let index in this.announcement.AnnouncementList) {
            let temp = this.announcement.AnnouncementList[index];
            if (this.id == temp.ID) {
              this.detail = temp;
              if (temp.AudioGuide) {
            this.audioFiles.default = temp.AudioGuide.default;
            this.audioFiles.fast = temp.AudioGuide.fast;
            this.audioFiles.slow = temp.AudioGuide.slow;
          }
              break;
            }
          }
        });
      } else if ("publicWelfare" == this.type) {
        this.$route.meta.breadcrumb = this.publicWelfareBreadcrumb;
        getPublicWelfare().then((response) => {
          this.publicWelfare = response.data;
          for (let index in this.publicWelfare.PublicWelfareList) {
            let temp = this.publicWelfare.PublicWelfareList[index];
            if (this.id == temp.ID) {
              this.detail = temp;
              if (temp.AudioGuide) {
            this.audioFiles.default = temp.AudioGuide.default;
            this.audioFiles.fast = temp.AudioGuide.fast;
            this.audioFiles.slow = temp.AudioGuide.slow;
          }
              break;
            }
          }
        });
      } else if ("employeeCareNews" == this.type) {
        this.$route.meta.breadcrumb = this.employeeCareNewsBreadcrumb;
        getEmployeeCareNews().then((response) => {
          this.employeeCareNews = response.data;
          for (let index in this.employeeCareNews.EmployeeCareNewsList) {
            let temp = this.employeeCareNews.EmployeeCareNewsList[index];
            if (this.id == temp.ID) {
              this.detail = temp;
              if (temp.AudioGuide) {
            this.audioFiles.default = temp.AudioGuide.default;
            this.audioFiles.fast = temp.AudioGuide.fast;
            this.audioFiles.slow = temp.AudioGuide.slow;
          }
              break;
            }
          }
        });
      } else if ("decree" == this.type) {
        this.$route.meta.breadcrumb = this.decreeBreadcrumb;
        getDecree().then((response) => {
          this.decree = response.data;
          for (let index in this.decree.DecreeList) {
            let temp = this.decree.DecreeList[index];
            if (this.id == temp.ID) {
              this.detail = temp;
              if (temp.AudioGuide) {
            this.audioFiles.default = temp.AudioGuide.default;
            this.audioFiles.fast = temp.AudioGuide.fast;
            this.audioFiles.slow = temp.AudioGuide.slow;
          }
              break;
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/detail/detail";
</style>
